import React from 'react'
import { DcButton, DcDropDown, DcInput, PixelFactoryContext } from 'pixel-base'
import ClickOutside from 'rechat-react-click-outside'
import styled from 'styled-components'

import { createCategory } from 'utils/api-routes.util'
import { ICollections, IPixelFactory } from '../../../../../../decl.d'

const AddNewCategory = (props: {
  categories: ICollections[]
  handleClose: (data: ICollections | null) => void
}) => {
  const { showSuccess, showFailure, showPageLoader, hidePageLoader } =
    React.useContext<IPixelFactory>(PixelFactoryContext)
  const { categories } = props
  const [newCategory, setNewCategory] = React.useState({
    category_name: '',
    parent_id: '',
  })
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    showPageLoader()
    createCategory(newCategory).subscribe((res) => {
      const response = res.response as {
        data: ICollections | { error: string }
      }
      hidePageLoader()
      if (response.data) {
        showSuccess('Successfully added')
        props.handleClose(response.data)
      } else {
        if (response.error) {
          showFailure(response.error)
        }
      }
    })
  }
  return (
    <ClickOutside onClickOutside={() => props.handleClose(null)}>
      <Form onSubmit={handleSubmit}>
        <InputLabel>Category Name</InputLabel>
        <FormGroup>
          <DcInput
            required
            type={'text'}
            name={'category_name'}
            placeholder={'Category Name'}
            value={newCategory.category_name}
            onChange={(e) =>
              setNewCategory({ ...newCategory, category_name: e.target.value })
            }
          />
        </FormGroup>
        <InputLabel>Parent Name</InputLabel>

        <FormGroup>
          <DcDropDown
            required
            options={[{ name: 'None', id: '' }, ...categories].map((status) => {
              return {
                label: status?.collection_id?.source_collection_name,
                value: status?.collection_id?.source_collection_id,
              }
            })}
            placeholder={'Parent Name'}
            value={newCategory.parent_id}
            onChange={(e) => {
              setNewCategory({ ...newCategory, parent_id: e.target.value })
            }}
          />
        </FormGroup>
        <FormGroup flexEnd>
          <DcButton type={'submit'} variant="primary">
            Save
          </DcButton>
        </FormGroup>
      </Form>
    </ClickOutside>
  )
}
const Form = styled.form`
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: flex-start;
  align-content: flex-start;
  gap: 10px;
`

const FormGroup = styled.div<{ flexEnd?: boolean }>`
  display: inline-flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: ${(props) => (props.flexEnd ? 'flex-end' : 'center')};
  align-items: flex-start;
  align-content: flex-start;
  width: 100%;
  flex-grow: 1;
  gap: 10px;
  .full-width {
    flex-grow: 1;
  }
`
const InputLabel = styled.label`
  font-size: 14px;
  font-weight: 500;
  color: #8e959c;
  /* margin-left: 10px; */
`
export default AddNewCategory
